import React from "react";

import styles from "./Condiciones.module.scss";
import { FormattedMessage } from "react-intl";

function Condiciones() {

    return (
        <div className={styles.main}>
            <div className={styles.wrap}>
                <div className={styles.logoBg} />
                <div className={styles.container}>
                    <div className={styles.textWrap}>
                        <div className={styles.title}><FormattedMessage id="terms_and_conditions_title" /></div>
                        <div className={styles.text}>
                            <div>
                                <h3><FormattedMessage id="terms_1_title" /></h3>
                                <p><FormattedMessage id="terms_1_p1" /></p>
                                <p><FormattedMessage id="terms_1_p2" /></p>

                                <h3><FormattedMessage id="terms_2_title" /></h3>
                                <p><FormattedMessage id="terms_2_p1" /></p>

                                <h3><FormattedMessage id="terms_3_title" /></h3>
                                <p><FormattedMessage id="terms_3_p1" /></p>
                                <p><FormattedMessage id="terms_3_p2" /></p>
                                <ul>
                                    <li><FormattedMessage id="terms_3_l1" /></li>
                                    <li><FormattedMessage id="terms_3_l2" /></li>
                                    <li><FormattedMessage id="terms_3_l3" /></li>
                                </ul>

                                <h3><FormattedMessage id="terms_4_title" /></h3>
                                <p><FormattedMessage id="terms_4_p1" /></p>
                                <p><FormattedMessage id="terms_4_p2" /></p>

                                <h3><FormattedMessage id="terms_5_title" /></h3>
                                <p><FormattedMessage id="terms_5_p1" /></p>

                                <h3><FormattedMessage id="terms_6_title" /></h3>
                                <p><FormattedMessage id="terms_6_p1" /></p>

                                <h3><FormattedMessage id="terms_7_title" /></h3>
                                <p><FormattedMessage id="terms_7_p1" /></p>

                                <h3><FormattedMessage id="terms_8_title" /></h3>
                                <p><FormattedMessage id="terms_8_p1" /></p>

                                <h3><FormattedMessage id="terms_9_title" /></h3>
                                <p><FormattedMessage id="terms_9_p1" /></p>

                                <h3><FormattedMessage id="terms_10_title" /></h3>
                                <p><FormattedMessage id="terms_10_p1" /></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Condiciones;